import {
  compose,
  withProps,
  branch,
} from 'recompose';
import { addMetaTagToHead } from '../Helper';

const META_NAME = 'robots';
export const isNoIndex = ({ noIndex = false }) => noIndex;

const isNoIndexMetaTagNotExist = () => !document.querySelector(`meta[name="${META_NAME}"]`);
const createNoIndexMeta = () => {
  addMetaTagToHead({
    name: META_NAME,
    content: 'noindex',
  });
};
export const withCreateNoIndexMetaIfNotExist = compose(
  branch(
    isNoIndexMetaTagNotExist,
    withProps(({ callbacks }) => ({
      callbacks: [...callbacks, createNoIndexMeta],
    }))
  ),
);

export const removeNoIndexMeta = () => {
  const tag = document.querySelector(`meta[name="${META_NAME}"]`);
  tag && tag.remove();
};

export const withNoIndexMeta = compose(
  branch(
    isNoIndex,
    withCreateNoIndexMetaIfNotExist,
    withProps(({ callbacks }) => ({
      callbacks: [...callbacks, removeNoIndexMeta]
    }))
  ),
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithNoIndex.js